/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as s from "react";
import { classNames as i, kendoThemeMaps as m } from "@progress/kendo-react-common";
const b = (o) => {
  const { size: a, className: r, ariaLabel: e, ariaControls: l, children: t } = o;
  return /* @__PURE__ */ s.createElement(
    "div",
    {
      className: i(
        "k-toolbar k-grid-toolbar k-toolbar-solid",
        {
          "k-toolbar-md": !a,
          [`k-toolbar-${m.sizeMap[a] || a}`]: a
        },
        r
      ),
      "aria-label": e,
      "aria-controls": l,
      role: "toolbar"
    },
    t
  );
};
b.displayName = "KendoReactGridToolbar";
export {
  b as GridToolbar
};
